// Generated by purs version 0.13.5
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Regex = require("../Data.String.Regex/index.js");
var Data_String_Regex_Flags = require("../Data.String.Regex.Flags/index.js");
var Data_String_Regex_Unsafe = require("../Data.String.Regex.Unsafe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Foreign_Index = require("../Foreign.Index/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Indexer_FSEntry = require("../Indexer.FSEntry/index.js");
var Indexer_MTime = require("../Indexer.MTime/index.js");
var Node_Path = require("../Node.Path/index.js");
var Category = (function () {
    function Category(value0) {
        this.value0 = value0;
    };
    Category.create = function (value0) {
        return new Category(value0);
    };
    return Category;
})();
var Item = (function () {
    function Item(value0) {
        this.value0 = value0;
    };
    Item.create = function (value0) {
        return new Item(value0);
    };
    return Item;
})();
var genericItems = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Category) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof Item) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Items (line 59, column 1 - line 59, column 48): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Category(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new Item(x.value0);
    };
    throw new Error("Failed pattern match at Items (line 59, column 1 - line 59, column 48): " + [ x.constructor.name ]);
});
var showItems = new Data_Show.Show(function (x) {
    return Data_Generic_Rep_Show.genericShow(genericItems)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "items";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "label";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "path";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Show.showArray(showItems)))))(new Data_Symbol.IsSymbol(function () {
        return "Category";
    })))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "files";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "label";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "previewImage";
    }))(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "basename";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "dirname";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "mtime";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showNumber))(Indexer_MTime.showMTime))(Data_Show.showString))(Data_Show.showString)))))(Data_Show.showString))(Data_Array_NonEmpty_Internal.showNonEmptyArray(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "basename";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "dirname";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "mtime";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showNumber))(Indexer_MTime.showMTime))(Data_Show.showString))(Data_Show.showString)))))))(new Data_Symbol.IsSymbol(function () {
        return "Item";
    }))))(x);
});
var fromFSEntry = function (entry) {
    var sortByMtime = function (dictPartial) {
        var $87 = Data_Array.sortWith(Data_Maybe.ordMaybe(Indexer_MTime.ordMTime))(function (v) {
            if (v instanceof Item) {
                return Data_Foldable.minimum(Indexer_MTime.ordMTime)(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray)(function (v1) {
                    return v1.mtime;
                })(v.value0.files));
            };
            throw new Error("Failed pattern match at Items (line 56, column 45 - line 56, column 93): " + [ v.constructor.name ]);
        });
        return function ($88) {
            return Data_Array.reverse($87($88));
        };
    };
    var isPreviewImage = function (v) {
        if (v instanceof Indexer_FSEntry.File) {
            return Data_String_Regex.test(Data_String_Regex_Unsafe.unsafeRegex("^gh-pages-preview-")(Data_String_Regex_Flags.noFlags))(v.value0.basename);
        };
        return false;
    };
    var mkItem = function (dictPartial) {
        return function (files) {
            var previewImage = Data_Functor.map(Data_Maybe.functorMaybe)(Indexer_FSEntry.unwrapFile())(Data_Foldable.find(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(isPreviewImage)(files));
            var label = Indexer_FSEntry.label()(Data_Array_NonEmpty.head(files));
            var files$prime = Data_Functor.map(Data_Functor.functorArray)(Indexer_FSEntry.unwrapFile())(Data_Array_NonEmpty.filter((function () {
                var $89 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                return function ($90) {
                    return $89(isPreviewImage($90));
                };
            })())(files));
            return new Item({
                label: label,
                previewImage: previewImage,
                files: Data_Maybe.fromJust()(Data_Array_NonEmpty.fromArray(files$prime))
            });
        };
    };
    var isDir = function (v) {
        if (v instanceof Indexer_FSEntry.Dir) {
            return true;
        };
        if (v instanceof Indexer_FSEntry.File) {
            return false;
        };
        throw new Error("Failed pattern match at Items (line 48, column 5 - line 48, column 32): " + [ v.constructor.name ]);
    };
    var go = function (dictPartial) {
        return function (v) {
            if (v instanceof Indexer_FSEntry.Dir) {
                var path = Node_Path.concat([ v.value0.dirname, v.value0.basename ]);
                var v1 = Data_Array.partition(isDir)(v.value0.content);
                var items = sortByMtime()(Data_Functor.map(Data_Functor.functorArray)(mkItem())(Data_Array["group'"](Indexer_FSEntry.ordFSEntry)(v1.no)));
                var categories = Data_Functor.map(Data_Functor.functorArray)(go())(v1.yes);
                return new Category({
                    label: v.value0.basename,
                    path: path,
                    items: Data_Array.concat([ categories, items ])
                });
            };
            throw new Error("Failed pattern match at Items (line 35, column 5 - line 35, column 38): " + [ v.constructor.name ]);
        };
    };
    return go()(entry);
};
var encodeItems = new Foreign_Generic_Class.Encode(function (v) {
    if (v instanceof Category) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("type")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("category")), Data_Tuple.Tuple.create("label")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.label)), Data_Tuple.Tuple.create("path")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.path)), Data_Tuple.Tuple.create("items")(Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(encodeItems))(v.value0.items)) ]));
    };
    if (v instanceof Item) {
        var encodeFileRec = function (v1) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("basename")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v1.basename)), Data_Tuple.Tuple.create("dirname")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v1.dirname)), Data_Tuple.Tuple.create("mtime")(Foreign_Generic_Class.encode(Indexer_MTime.encodeMTime)(v1.mtime)), Data_Tuple.Tuple.create("size")(Foreign_Generic_Class.encode(Foreign_Generic_Class.numberEncode)(v1.size)) ]));
        };
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("type")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("item")), Data_Tuple.Tuple.create("label")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.label)), Data_Tuple.Tuple.create("previewImage")(Foreign_Generic_Class.encode(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.foreignEncode))(Data_Functor.map(Data_Maybe.functorMaybe)(encodeFileRec)(v.value0.previewImage))), Data_Tuple.Tuple.create("files")(Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.foreignEncode))(Data_Functor.map(Data_Functor.functorArray)(encodeFileRec)(Data_Array_NonEmpty.toArray(v.value0.files)))) ]));
    };
    throw new Error("Failed pattern match at Items (line 63, column 1 - line 85, column 14): " + [ v.constructor.name ]);
});
var decodeItems = new Foreign_Generic_Class.Decode(function (v) {
    var decodeFileRec = function (w) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(w)("basename"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v1) {
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(w)("dirname"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v2) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(w)("mtime"))(Foreign_Generic_Class.decode(Indexer_MTime.decodeMTime)))(function (v3) {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(w)("size"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.numberDecode)))(function (v4) {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))({
                            basename: v1,
                            dirname: v2,
                            mtime: v3,
                            size: v4
                        });
                    });
                });
            });
        });
    };
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("type"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v1) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("label"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v2) {
            if (v1 === "category") {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("path"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v3) {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("items"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(decodeItems))))(function (v4) {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Category({
                            label: v2,
                            path: v3,
                            items: v4
                        }));
                    });
                });
            };
            if (v1 === "item") {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("previewImage"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.foreignDecode))))(function (v3) {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))((function () {
                        if (v3 instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Data_Maybe.Nothing.value);
                        };
                        if (v3 instanceof Data_Maybe.Just) {
                            return Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Data_Maybe.Just.create)(decodeFileRec(v3.value0));
                        };
                        throw new Error("Failed pattern match at Items (line 100, column 25 - line 102, column 45): " + [ v3.constructor.name ]);
                    })())(function (v4) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("files"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.foreignDecode))))(function (v5) {
                            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))((function (dictPartial) {
                                var $91 = Data_Maybe.fromJust();
                                return function ($92) {
                                    return $91(Data_Array_NonEmpty.fromArray($92));
                                };
                            })())(Data_Traversable.traverse(Data_Traversable.traversableArray)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(decodeFileRec)(v5)))(function (v6) {
                                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Item({
                                    label: v2,
                                    previewImage: v4,
                                    files: v6
                                }));
                            });
                        });
                    });
                });
            };
            return Foreign.fail(Foreign.ForeignError.create("invalid type: " + v1));
        });
    });
});
module.exports = {
    Category: Category,
    Item: Item,
    fromFSEntry: fromFSEntry,
    genericItems: genericItems,
    showItems: showItems,
    encodeItems: encodeItems,
    decodeItems: decodeItems
};
